const rescueCategories = [
  'police',
  'fire',
  'medical',
  'security',
];

export default rescueCategories;
